@if (discriminatorTypeBoolean != discriminator.idDiscriminatorType) {
  <div class="descricao descricao-com-info">
    <span matTooltip="{{discriminator.description}}" [matTooltipPosition]="'above'" class="texto">
      {{discriminator.discriminatorName}}
      <a><img src="assets/images/icode-radio-ask.svg" /></a>
    </span>
    <span (click)="abrirModal()" class="info">{{discriminatorsValues[discriminator.idDiscriminatorType]}}</span>
  </div>
}
@if (discriminatorTypeBoolean == discriminator.idDiscriminatorType) {
  <div class="descricao">
    <span matTooltip="{{discriminator.description}}" [matTooltipPosition]="'above'" class="texto">
      {{discriminator.discriminatorName}}
      <a><img src="assets/images/icode-radio-ask.svg" /></a>
    </span>
  </div>
}